import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  name: 'Sandra (Hund: Balu, Labrador, 4 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1529927066849-79b791a69825?w=100&h=100&fit=crop&crop=faces',
  rating: 5,
  date: '12.05.2024',
  text: 'Ich war skeptisch, aber nach 2 Wochen hatte Balu zum ersten Mal wieder normalen Stuhl. Wir sind so erleichtert.'
}, {
  name: 'Michael (Hund: Rocky, Mischling, 7 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1543466835-00a7907e9de1?w=100&h=100&fit=crop&crop=faces',
  rating: 5,
  date: '03.06.2024',
  text: 'Rocky hatte wochenlang Würgen und Magengrummeln nach dem Fressen. Nach dem Topping hat sich das innerhalb von 10 Tagen komplett gelegt.'
}, {
  name: 'Lisa (Hund: Emma, Golden Retriever, 2 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1633722715463-d30f4f325e24?w=100&h=100&fit=crop&crop=faces',
  rating: 5,
  date: '28.05.2024',
  text: 'Emmas Bauch hat sich endlich beruhigt. Sie frisst wieder mit Appetit und das ständige Grummeln ist weg. Ein echter Lebensretter!'
}];
function Stars({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-129">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" style={{
      color: '#D4A843'
    }} data-id="element-130" />)}
    </div>;
}
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function TestimonialsSection() {
  return <section className="w-full py-16" style={{
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-131">
      <div className="max-w-3xl mx-auto px-4" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-133">
          <h3 className="font-handwritten text-3xl md:text-4xl mb-3" style={{
          color: 'var(--color-green)'
        }} data-id="element-134">
            Das sagen andere Hundebesitzer
          </h3>
          <p className="text-base" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-135">
            Echte Erfahrungen von echten Hundemenschen
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-136">
          {testimonials.map(t => <motion.div key={t.name} variants={itemVariants} className="rounded-xl p-6 border" style={{
          backgroundColor: 'white',
          borderColor: 'var(--color-border)'
        }} data-id="element-137">
              <div className="flex flex-wrap items-center gap-3 mb-3" data-id="element-138">
                <div className="w-8 h-8 rounded-full overflow-hidden bg-gray-100 flex-shrink-0" data-id="element-139">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" data-id="element-140" />
                </div>
                <p className="text-sm font-semibold" style={{
              color: 'var(--color-text)'
            }} data-id="element-141">
                  {t.name}
                </p>
                <Stars count={t.rating} data-id="element-142" />
                <span className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border" style={{
              color: 'var(--color-green)',
              borderColor: 'var(--color-green)',
              backgroundColor: 'var(--color-green-light)'
            }} data-id="element-143">
                  <BadgeCheckIcon className="w-3.5 h-3.5" data-id="element-144" />
                  Verifizierter Kunde
                </span>
              </div>
              <p className="text-base leading-relaxed whitespace-pre-line" style={{
            color: 'var(--color-text)'
          }} data-id="element-145">
                „{t.text}"
              </p>
              <p className="mt-3 text-xs text-right" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-146">
                {t.date}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}